import axios, { AxiosInstance } from "axios"
import { useAdminSessionInterceptor } from "src/domains/http/interceptors/use-admin-session-interceptor"

import { authResponseErrorInterceptor } from "./interceptors/auth-interceptor"

function apiPath(version: string) {
  return `${import.meta.env.VITE_MINUT_API_BASE_URL}/${version}`
}

export const DEFAULT_BASE_URL = apiPath("v8")

export const apiClient: AxiosInstance = axios.create({
  baseURL: DEFAULT_BASE_URL,
  timeout: 60 * 1000, // 1 minute
  withCredentials: true, // required for session cookie to be sent to BE
  headers: {
    "Content-Type": "application/json",
  },
})

apiClient.interceptors.request.use(useAdminSessionInterceptor)
apiClient.interceptors.response.use(undefined, authResponseErrorInterceptor)
